import { clsx } from 'clsx'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  color?: 'primary' | 'white' | 'gray'
  className?: string
}

const Spinner = ({ size = 'md', color = 'primary', className }: SpinnerProps) => {
  const sizes = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
  }

  const colors = {
    primary: 'text-primary-600',
    white: 'text-white',
    gray: 'text-gray-400',
  }

  return (
    <svg
      className={clsx('animate-spin', sizes[size], colors[color], className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  )
}

export default Spinner

// Componente per loading a schermo intero
export const FullPageSpinner = ({ message }: { message?: string }) => (
  <div className="fixed inset-0 bg-white bg-opacity-75 flex flex-col items-center justify-center z-50">
    <Spinner size="lg" />
    {message && <p className="mt-4 text-gray-600">{message}</p>}
  </div>
)

// Componente per loading inline
export const InlineSpinner = ({
  message,
  className,
}: {
  message?: string
  className?: string
}) => (
  <div className={clsx('flex items-center justify-center py-8', className)}>
    <Spinner />
    {message && <span className="ml-3 text-gray-600">{message}</span>}
  </div>
)
